<mat-expansion-panel
    [(expanded)]="expanded"
    (expandedChange)="expandedChange.emit($event)"
    [hideToggle]="hideToggle"
    [disabled]="locked"
    #panel>

    <mat-expansion-panel-header>
        <mat-panel-title>
            <cll-slide-toggle (click)="$event.stopImmediatePropagation()"
                              *ngIf="showHeaderToggle"
                              [(ngModel)]="panel.expanded"
                              [colour]="'secondary'"
                              [disabled]="locked"
                              [ngModelOptions]="{ standalone: true }"
                              [size]="'medium'" />
            <ng-content select="[app-panel-title]"></ng-content>
        </mat-panel-title>

        <mat-panel-description>
            <div class="float-right">
                <ng-content select="[app-panel-description]"></ng-content>
            </div>
        </mat-panel-description>
    </mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
        <ng-content></ng-content>
    </ng-template>

</mat-expansion-panel>
